<template>
  <vs-row vs-justify="center" id="organizations-box">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
    >
      <vs-card>
        <vs-tabs :value="activeTab">
          <vs-tab
            :label="$t('Organization.OrganizationShow.Tabs.BasicInformation')"
            icon="info"
            id="information-tab"
          >
            <vs-row class="mt-4">
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="12"
                vs-xs="12"
              >
                <vs-row class="mt-4">
                  <vs-col vs-lg="6" vs-xs="12" vs-sm="12" class="w-10">
                    <vs-row>
                      <vs-col vs-w="6">
                        <vs-input
                          :label="$t('Monitoring.Name')"
                          v-model="kiosk.name"
                          class="w-100 mb-2"
                          disabled
                        />
                      </vs-col>
                      <vs-col vs-w="6">
                        <vs-input
                          :label="$t('Monitoring.key')"
                          v-model="kiosk.business_name"
                          class="w-100 mb-2"
                          disabled
                        />
                      </vs-col>
                    </vs-row>
                    <vs-row>
                      <vs-col vs-w="6">
                        <vs-input
                          :label="$t('Monitoring.last_ping_status')"
                          :value="kiosk.last_ping_status ? 'true' : 'false'"
                          class="w-100 mb-2 mt-2"
                          disabled
                        />
                      </vs-col>

                      <vs-col vs-w="6">
                        <vs-input
                          :label="$t('Monitoring.last_ping_date_time')"
                          v-model="kiosk.last_ping_date_time"
                          class="w-100 mb-2 mt-2"
                          disabled
                        />
                      </vs-col>
                    </vs-row>
                  </vs-col>

                  <vs-col vs-w="6">
                    <div>
                      <div slot="header">
                        <br />
                        <vs-table :data="pings" :total="totalItems"
                          max-items="10">
                          <template slot="thead">
                            <vs-th>{{ $t("Pings.LastTimesPings") }}</vs-th>
                          </template>
                          <template slot-scope="{ data }">
                            <vs-tr
                              :data="tr"
                              :key="indextr"
                              v-for="(tr, indextr) in data"
                            >
                              <vs-td :data="data[indextr].created_at">
                                {{
                                  new Date(
                                    data[indextr].created_at
                                  ).toLocaleString(
                                    "en-US",
                                    { timeZone: "UTC" } + 1
                                  )
                                }}
                                <vs-td> </vs-td>
                                <vs-td> </vs-td>

                                <vs-td>
                                  <img
                                    v-if="data[indextr].screenshot_data"
                                    height="100px"
                                    width="150px"
                                    :src="data[indextr].screenshot_data"
                                    @click="openFullScreenImage"
                                  />
                                  <span v-else>no screenshoot found</span>
                                </vs-td>
                              </vs-td>
                            </vs-tr>
                          </template>
                        </vs-table>
                        <vs-pagination class="mt-3" :total="totalPages" @change="handleChangePage" v-model="currentPage"></vs-pagination>
                      </div>
                    </div>
                  </vs-col>
                </vs-row>

                <br />
              </vs-col>
            </vs-row>
          </vs-tab>
        </vs-tabs>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import { managerService, pingsService } from "../../_services";
import { gmapApi } from "vue2-google-maps";
import router from "../../_helpers/router";
import index from "../../components/Team/index";

export default {
  name: "Organization",
  data: () => ({
    title: "Organization",
    activeTab: 0,
    activeUpdatePrompt: 0,
    organization: {},
    kiosk: {},
    teamTotalPages: 0,
    teamCurrentPage: 1,
    currentLocation: { lat: 0, lng: 0 },
    markers: [],
    pings: [],
    totalPages: 0,
    currentPage: 0,
    totalItems: 0,
    managers: {},
    departments: [],
    activePrompt: false,
    fname: "",
    lname: "",
    telephone: "",
    email: "",
    password: "",
    password_confirm: "",
    role: "",
    department: "",
    photo: "",
    editPhoto: "",
    accountUpdate: {},
    selected: {},
    errors: {
      fname: false,
      lname: false,
      telephone: false,
      email: false,
      password: false,
      password_confirm: false,
      role: false,
      selected: {
        fname: false,
        lname: false,
        telephone: false,
        email: false,
        password: false,
        password_confirm: false,
        role: false,
      },
    },
  }),
  computed: {
    google: gmapApi,
  },
  methods: {
    notify(title, text, type) {
      this.$vs.notify({
        color: type,
        title: title,
        text: text,
      });
    },

    openFullScreenImage() {
      const imgElement = event.target;
      imgElement.requestFullscreen();
    },

    showLoading() {
      this.$vs.loading({
        container: "#organizations-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#organizations-box > .con-vs-loading");
    },
    updateCoordinates(location) {
      this.markers[0].position = {
        lat: location.latLng.lat(),
        lng: location.latLng.lng(),
      };
    },
    goToNextTab(currentStep) {
      this.$tours["SettingsBusiness"].nextStep();
      if (currentStep == 1) {
        this.activeTab = 1;
      } else if (currentStep == 2) {
        this.activeTab = 2;
      }
    },
    goToNextPage() {
      router.push({ path: "/settings/team?istour=on" });
    },
    close() {
      this.fname = "";
      this.lname = "";
      this.telephone = "";
      this.email = "";
      this.password = "";
      this.password_confirm = "";
      this.role = "";
    },
    handleManagersChangePage(page) {
      managerService.getPage(this.$route.params.id, page).then((data) => {
        this.managers = data.managerAccounts.data;
      });
    },
    handleChangePage(page) {
      this.showLoading();
      pingsService.getByIdPagination(this.$route.params.id, page).then((data) => {
      this.kiosk = data.kiosk;
      this.kiosk.last_ping_date_time = this.$moment(this.kiosk.last_ping_date_time).format('lll')
      this.pings = data.pings.data;
      this.totalPages = data.pings.last_page;
      this.currentPage = data.pings.current_page;
      this.totalItems = data.pings.total;
      let location = {
        lat: parseFloat(this.kiosk.lat),
        lng: parseFloat(this.kiosk.lng),
      };
      this.markers.push({ position: location });
      this.currentLocation = location;
    }).catch(function (err) {console.log(err)}).finally(function () {this.hideLoading()}.bind(this));
    }
  },
  beforeMount() {
    this.currentPage = 1;
  },
  components: {
    index,
  },
};
</script>

<style></style>
